<template>
	<v-container fluid>
		<v-row>
			<v-col cols="9">
				<categorie-index-table />
			</v-col>
			<v-col>
				<categorie-create-form />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapActions } from 'vuex'

import CategorieIndexTable from '../components/categorie/IndexTable'
import CategorieCreateForm from '../components/categorie/CreateForm'

export default {
	name: 'Categorie',

	components: {
		CategorieIndexTable,
		CategorieCreateForm,
	},

	methods: {
		...mapActions(['fetchCategories']),
	},

	async mounted() {
		await this.fetchCategories()
	},
}
</script>
